import React from 'react';
import {layoutSelectors} from 'features/layout/redux';
import {useSelector} from 'react-redux';
import {IDiplomatObject} from 'types/DiplomatObject';

export const useFilteredTransactions = (filter?: string) => {
   const transactions = useSelector(layoutSelectors.transactionsSelector) as IDiplomatObject[];
   const synchronizations = useSelector(
      layoutSelectors.synchronizationsSelector
   ) as IDiplomatObject[];

   const filtered = React.useMemo(() => {
      const items = transactions.concat(synchronizations);
      const _filter = filter?.toLowerCase();

      return _filter ? items.filter((t) => t.name.toLowerCase().indexOf(_filter) >= 0) : items;
   }, [transactions, synchronizations, filter]);

   return filtered;
};
